module.exports = "<div class=ui-grid-cell-contents> <a class=\"text-xs m-r-md\" ng-click=grid.appScope.usrVM.confirmDisableUser(row.entity) ng-if=\"row.entity.userRoleId == 36 || row.entity.userRoleId == 37 || grid.appScope.usrVM.roleId == 15\"> <i class=\"icon mdi-action-delete i-16 dark-icon m-r-xs\"></i> Eliminar </a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/generalSettings/users/list/userActionsCell.html
// module id = 271
// module chunks = 0